import styled from 'styled-components';

export const Container = styled.div`
  .btn-hide-search {
    right: -30px;
    top: 20px;
    height: 60px;
    width: 60px;
    background: #fff;
    border-radius: 100%;
    padding: 6px 5px 0 0;
    text-align: right;
    transition: all 1s;

    @media only screen and (max-width: 768px) {
      display: none;
    }

    i {
      transform: rotate(180deg);
    }

    &:hover {
      background: #fff;
    }
  }

  .hide-bar {
    .btn-hide-search {
      i {
        transform: rotate(0deg);
      }
    }
  }

  .btn-hide-documents {
    right: -30px;
    top: 20px;
    height: 34px;
    width: 30px;
    background-color: #03d6a5 !important;
    border-radius: 0 5px 5px 0;
    text-align: right;
    transition: all 1s;
  }

  .filter {
    &-button {
      @extend .shadow;
    }

    @media (min-width: 992px) {
      &-bar {
        position: fixed;
        top: 3.5em;
        left: 5px;
        height: 100%;
        background: #fff;
        border-right: 1px solid $gray-300;
        z-index: 13;
        transition: all 1s;

        &.hasTopBanner {
          top: 136px;
        }

        &.hide-bar {
          transform: translateX(-100%);
        }
      }

      &-form {
        max-height: 85%;
        overflow-x: hidden;
        overflow-y: scroll;
        position: relative;

        &::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 7px;

          &-thumb {
            border-radius: 4px;
            background-color: rgba(0, 0, 0, 0.5);
            -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
          }
        }
      }

      &-button {
        position: fixed;
        bottom: 0;
        left: 5px;
      }
    }
  }

  .title {
    font-size: 18px;
    color: ${(props) => props.theme.$gray700};
  }

  span {
    color: #666666;
    font-size: 14px;
  }

  .modulo-count {
    font-size: 12px;
    color: ${(props) => props.theme.$success};
  }

  a .title {
    font-size: 14px;
    color: ${(props) => props.theme.$gray700};
  }

  .CircularProgressbar .CircularProgressbar-path {
    stroke: ${(props) => props.theme.$success};
  }

  .CircularProgressbar .CircularProgressbar-text {
    fill: ${(props) => props.theme.$gray700};
  }

  .btn-lesson {
    color: #333333;
    padding: 0px;
    font-size: 14px;
    margin: 0px;
    text-align: left;
  }

  .modules-list:hover {
    background: ${(props) => props.theme.$gray200};
  }

  .active-topic {
    content: '';
    width: 7px;
    height: 100%;
    background: ${(props) => props.theme.$primary_green};
    position: absolute;
    left: 20px;
  }

  .nav-arrow {
    transform: rotate(180deg);
    transition: transform 0.5s;
  }

  .collapsed {
    .nav-arrow {
      transform: rotate(0deg);
    }
  }
`;
